import { IRejection, IWarning } from '@cbgms/api'
import { DeleteResponseToMessageMapper } from '@cbgms/components/form/Dialogs/DeleteModalContainer'
import { IRejectionMessage } from '@cbgms/components/form/Dialogs/RejectionMessage'
import { i18next } from 'app-support/contexts/I18nContext'

export const DefaultRejection = (): IRejectionMessage => ({
  title: i18next.t('error.delete.default_error_title'),
  button: i18next.t('error.delete.default_error_button'),
  description: '',
  type: 'default',
  link: ''
})

export const DeleteRejections: IRejectionMessage[] = [
  {
    type: 'product_group',
    title: 'error_default_productgroup_title',
    description: 'error_default_productgroup_description'
  }
]

export const DefaultWarning = (): IRejectionMessage => ({
  title: i18next.t('error.delete.default_error_title'),
  button: i18next.t('error.delete.default_error_button'),
  description: '',
  type: 'default',
  link: ''
})

const DeleteWarnings: IRejectionMessage[] = []

export const mapRejectionToMessage: DeleteResponseToMessageMapper = (
  rejections: (IRejection | IWarning)[],
  item,
  options
): IRejectionMessage[] => {
  const deleteConfig = options?.isError ? DeleteRejections : DeleteWarnings

  const initialValue: IRejectionMessage[] = []

  const mappedRejections = rejections.reduce((result, rejection) => {
    const existingRejection = result.find(mappedRejection => mappedRejection.type === rejection.Type)

    if (existingRejection) {
      existingRejection.UUIDs!.push(rejection.UUID)
      return result
    }

    const deleteRejection = deleteConfig.find(deleteRejection => deleteRejection.type === rejection.Type)

    if (!deleteRejection) {
      return result
    }

    const displayRejection: IRejectionMessage = {
      type: rejection.Type,
      title: i18next.t(`error.delete.${deleteRejection.title}`, { item }),
      description: i18next.t(`error.delete.${deleteRejection.description}`),
      button: deleteRejection.button && i18next.t(`error.delete.${deleteRejection.button}`),
      link: deleteRejection.link,
      UUIDs: [rejection.UUID]
    }

    return [...result, displayRejection]
  }, initialValue)

  return mappedRejections.length > 0 ? mappedRejections : [options?.isError ? DefaultRejection() : DefaultWarning()]
}
